import { render, staticRenderFns } from "./ProductListInCategory.vue?vue&type=template&id=a275136e&scoped=true"
import script from "./ProductListInCategory.vue?vue&type=script&lang=js"
export * from "./ProductListInCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductListInCategory.vue?vue&type=style&index=0&id=a275136e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275136e",
  null
  
)

export default component.exports